module.exports = __webpack_public_path__ + "static/media/icon-dustbin.4d0081db.svg";